import React from 'react';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import {
  FadeInBox,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ExecuteSelectLoadingPage/FadeInBox';
import PropTypes from 'prop-types';

export const MoneyflowsSectionTabWrapper = ({ children }) => {
  return (
    <LottieLoadingLayout>
      <FadeInBox>
        {children}
      </FadeInBox>
    </LottieLoadingLayout>
  );
};

MoneyflowsSectionTabWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
